import React from 'react';
import Svg from '../Svg';

interface IPhoneLightIconProps {
  children?: React.ReactNode;
  className: string;
}

export default function PhoneLightIcon(
  props: IPhoneLightIconProps,
): JSX.Element {
  return (
    <Svg width="18" height="18" viewBox="0 0 512 512" fill="none" {...props}>
      <path
        fill="#b1a07e"
        d="M487.8 24.1L387 .8c-14.7-3.4-29.8 4.2-35.8 18.1l-46.5 108.5c-5.5 12.7-1.8 27.7 8.9 36.5l53.9 44.1c-34 69.2-90.3 125.6-159.6 159.6l-44.1-53.9c-8.8-10.7-23.8-14.4-36.5-8.9L18.9 351.3C5 357.3-2.6 372.3.8 387L24 487.7C27.3 502 39.9 512 54.5 512 306.7 512 512 307.8 512 54.5c0-14.6-10-27.2-24.2-30.4zM55.1 480l-23-99.6 107.4-46 59.5 72.8c103.6-48.6 159.7-104.9 208.1-208.1l-72.8-59.5 46-107.4 99.6 23C479.7 289.7 289.6 479.7 55.1 480z"
      />
    </Svg>
  );
}
